export default __webpack_public_path__ + "static/media/umb-com6.3570a32b.jpg";